import React, { useEffect } from 'react';
import Image from '@tiptap/extension-image';
import { Table } from '@tiptap/extension-table';
import TableCell from '@tiptap/extension-table-cell';
import TableHeader from '@tiptap/extension-table-header';
import TableRow from '@tiptap/extension-table-row';
import { EditorContent, useEditor } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import styles from './RulesViewer.module.scss';

const EMPTY_DOC = { type: 'doc', content: [{ type: 'paragraph' }] };

const ViewerImage = Image.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      width: {
        default: null,
        parseHTML: (el) => el.getAttribute('width'),
        renderHTML: (a) => (a.width ? { width: a.width } : {}),
      },
      height: {
        default: null,
        parseHTML: (el) => el.getAttribute('height'),
        renderHTML: (a) => (a.height ? { height: a.height } : {}),
      },
    };
  },
});

interface RulesViewerProps {
  layout?: Record<string, unknown> | null;
}

const RulesViewer: React.FC<RulesViewerProps> = ({ layout }) => {
  const editor = useEditor({
    editable: false,
    extensions: [
      StarterKit,
      ViewerImage,
      Table.configure({ resizable: false }),
      TableRow,
      TableHeader,
      TableCell,
    ],
    content: layout && Object.keys(layout).length > 0 ? layout : EMPTY_DOC,
  });

  useEffect(() => {
    if (!editor) return;
    const content =
      layout && Object.keys(layout).length > 0 ? layout : EMPTY_DOC;
    editor.commands.setContent(content, { emitUpdate: false });
  }, [editor, layout]);

  return (
    <div className={styles.viewer}>
      <EditorContent editor={editor} />
    </div>
  );
};

export default RulesViewer;
